import React from 'react';
import { DashboardPresentation } from './dashboard-presentation';
import { useEffect, useState } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { appConstant, apiUrl, colorsList, bankCard, showAffiliateUsageChart } from '@constants';
import { getAuthToken, getAuthKey, setStartDate, getRandomColors, getKeyAndToken, isAuth, encryptCompanyId } from '@helpers';
import Selectors from '@sharedComponent/app-action-reducer/selectors';
import ActionsApp from '@sharedComponent/app-action-reducer/action';

const dateFormat = 'MM/DD/YYYY';

const bardata = {
	legend: {
		display: true,
		align: 'start',
		position: 'bottom',
		labels: {
			usePointStyle: true,
			fontFamily: 'Gilroy-Medium',
			fontSize: 10,
			padding: 25,
			fontColor: '#253D5C',
		},
	},
	responsive: false,
	maintainAspectRatio: false,
	options: {
		cornerRadius: 8,
		scales: {
			yAxes: [
				{
					borderDash: 2,
					gridLines: {
						display: false,
						borderDash: [5],
						borderDashOffset: 100,
					},
					ticks: {
						beginAtZero: true,
						fontColor: '#253D5C',
						fontSize: 12,
						fontFamily: 'Gilroy-Medium',
					},
				},
			],
			xAxes: [
				{
					barPercentage: 0.6,
					ticks: {
						beginAtZero: true,
						fontColor: '#253D5C',
						fontSize: 12,
						fontFamily: 'Gilroy-Medium',
					},
					gridLines: {
						display: false,
					},
				},
			],
		},
	},
	labels: [],
	datasets: [],
};
const bardata1 = {
	legend: {
		display: true,
		align: 'start',
		position: 'bottom',
		labels: {
			usePointStyle: true,
			fontFamily: 'Gilroy-Medium',
			fontSize: 10,
			padding: 25,
			fontColor: '#253D5C',
		},
	},
	responsive: false,
	maintainAspectRatio: false,
	options: {
		cornerRadius: 8,
		scales: {
			yAxes: [
				{
					borderDash: 2,
					gridLines: {
						display: false,
						borderDash: [5],
						borderDashOffset: 100,
					},
					ticks: {
						beginAtZero: true,
						fontColor: '#253D5C',
						fontSize: 12,
						fontFamily: 'Gilroy-Medium',
					},
				},
			],
			xAxes: [
				{
					barPercentage: 0.6,
					ticks: {
						beginAtZero: true,
						fontColor: '#253D5C',
						fontSize: 12,
						fontFamily: 'Gilroy-Medium',
					},
					gridLines: {
						display: false,
					},
				},
			],
		},
	},
	labels: [],
	datasets: [],
};

const linedata = {
	legend: {
		align: 'start',
		position: 'bottom',
		labels: {
			usePointStyle: true,
			fontFamily: 'Gilroy-Medium',
			fontSize: 10,
			padding: 25,
			fontColor: '#253D5C',
		},
	},
	options: {
		scales: {
			yAxes: [
				{
					borderDash: 2,
					gridLines: {
						display: false,
						borderDash: [5],
						borderDashOffset: 100,
					},
					ticks: {
						beginAtZero: true,
						fontColor: '#253D5C',
						fontSize: 12,
						fontFamily: 'Gilroy-Medium',
					},
				},
			],
			xAxes: [
				{
					ticks: {
						beginAtZero: true,
						fontColor: '#253D5C',
						fontSize: 12,
						fontFamily: 'Gilroy-Medium',
					},
					gridLines: {
						display: false,
					},
				},
			],
		},
	},
	labels: [],
	datasets: [],
};

const DashboardFunctional = ({ props, userDetails, removeUser }) => {
	const [termsModalVisible, setTermsModalVisible] = useState(false);
	const history = useHistory();
	const [state, setState] = useState({
		loading: true,
		accessLevel: '',
		userName: '',
		profileImage: '',
		imageSrc: '',
		isActiveRoute: 1,
		authToken: '',
		coverImage: null,
	});
	const [commissionProfileData, setcommissionProfileData] = useState({
		commissionProfilesLoading: true,
		data: [],
	});

	const [performanceChartLoading, setPerformanceChartLoading] = useState(false);

	const [performanceData, setPerformanceData] = useState({
		startDate: moment(setStartDate('LAST')).format(dateFormat),
		endDate: new Date(),
		numberOfObjectsPerPage: 5,
		pageNumber: 1,
		dateFilter: 'LAST',
		chartDataType: 'Sales',
		labels: [],
		campaignList: [],
		campaignValue: [],
		datasets: [],
		datasetsTemp: [],
		isOpenDatePicker: false,
	});

	const [affiliateData, setAffiliateData] = useState({
		startDate: moment(setStartDate('LAST')).format(dateFormat),
		endDate: new Date(),
		datasets: [],
		labels: [],
		dateFilter: 'LAST',
		numberOfObjectsPerPage: 5,
		pageNumber: 1,
		chartDataType: 'Sales',
		campaignList: [],
		campaignValue: [],
		datasetsTemp: [],
		isOpenDatePicker: false,
	});

	const [reportData, setreportData] = useState({
		reportTableData: [],
		reportLoading: false,
	});

	const getAllCampaigns = async () => {
		const { authKey, authToken } = getKeyAndToken();
		setreportData({
			...reportData,
			reportLoading: true,
		});
		Axios.get(`${appConstant.domain}${apiUrl.GET_ALL_CAMPAIGNS}${authKey}`, {
			headers: {
				Authorization: authToken,
			},
		})
			.then((result) => {
				setreportData({
					...reportData,
					reportTableData: result.data.messages.message,
					reportLoading: false,
				});
			})
			.catch((err) => {
				setreportData({
					...reportData,
					reportLoading: false,
				});
			});
	};

	const getPerfomanceChartData = async (request) => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();
		setPerformanceChartLoading(true);
		Axios.get(`${appConstant.domain + apiUrl.GET_PERFORMANCE_CHAERT}`, {
			headers: { Authorization: authToken },
			params: {
				authKey: authKey,
				chartOptions: request.chartDataType || 'Sales',
				startDate: moment(request.startDate).format(dateFormat) || moment(new Date().setDate(new Date().getDate() - 7)).format(dateFormat),
				endDate: moment(request.endDate).format(dateFormat) || moment(new Date()).format(dateFormat),
				numberOfObjectsPerPage: request.numberOfObjectsPerPage || 5,
				pageNumber: request.pageNumber || 1,
			},
		})
			.then((response) => {
				// if (response.data.result == 'SUCCESS') {
				let labels = [];
				let datasets = [];
				new Promise((resolve) => {
					labels = response.data && response.data.messages && response.data.messages.labels ? response.data.messages.labels : [];

					let labe = [];
					labels.forEach((e, index) => {
						labe[index] = moment(e).format(dateFormat);
					});
					let campaignList = (response.data && response.data.messages && response.data.messages.campaignName) || [];
					datasets =
						response.data && response.data.messages && response.data.messages.chartDateSets ? response.data.messages.chartDateSets : [];
					if (
						response.data &&
						response.data.messages &&
						response.data.messages.chartDateSets &&
						response.data.messages.chartDateSets.length > 0
					) {
						datasets.map((value, i) => {
							let random = colorsList[i] || getRandomColors();

							value.type = state.chartType || 'line';
							value.fill = false;
							value.barPercentage = 0.3;
							value.backgroundColor = random;
							value.borderColor = random;
							value.hoverBackgroundColor = random;
							value.hoverBorderColor = random;
							// value.backgroundColor = '#0079FE';
							// value.borderColor = '#0079FE';
							// value.hoverBackgroundColor = '#0079FE';
							// value.hoverBorderColor = '#0079FE';
							value.borderWidth = 0;
							value.maxBarThickness = 15;
							value.minBarLength = 0.3;
							// value.barThickness = 5;
							value.barPercentage = 1;
							value.categoryPercentage = 0.2;
							return value;
						});

						resolve({ labels: labe, datasets, campaignList });
					} else {
						resolve({ labels, datasets, campaignList });
					}
				}).then((data) => {
					setPerformanceData({
						...performanceData,
						...request,
						labels: data.labels || [],
						datasets: data.datasets || [],
					});
					setPerformanceChartLoading(false);
				});
			})
			.catch(() => {
				setPerformanceChartLoading(false);
			});
	};

	const [affiliateChartLoading, setaffiliateChartLoading] = useState(false);
	const [chartLoading, setchartLoading] = useState(false);
	const [commissionData, setCommissionData] = useState({
		startDate: moment(setStartDate('LAST')).format(dateFormat),
		endDate: new Date(),
		numberOfObjectsPerPage: 5,
		pageNumber: 1,
		dateFilter: 'LAST',
		chartDataType: 'Sales',
		labels: [],
		datasetsTemp: [],
		campaignList: [],
		campaignValue: [],
		datasets: [],
	});

	const getCommissionChartData = async (request) => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();
		setchartLoading(true);
		Axios.get(`${appConstant.domain + apiUrl.GET_COMMISSION_CHAERT}`, {
			headers: { Authorization: authToken },
			params: {
				authKey: authKey,
				chartOptions: request.chartDataType || 'Sales',
				startDate: moment(request.startDate).format(dateFormat) || moment(new Date().setDate(new Date().getDate() - 7)).format(dateFormat),
				endDate: moment(request.endDate).format(dateFormat) || moment(new Date()).format(dateFormat),
				numberOfObjectsPerPage: request.numberOfObjectsPerPage || 5,
				pageNumber: request.pageNumber || 1,
			},
		})
			.then((response) => {
				// if (response.data.result == 'SUCCESS') {
				let labels = [];
				let datasets = [];
				new Promise((resolve) => {
					labels = response.data && response.data.messages && response.data.messages.labels ? response.data.messages.labels : [];

					let labe = [];
					labels.forEach((e, index) => {
						labe[index] = moment(e).format(dateFormat);
					});
					let campaignList = (response.data && response.data.messages && response.data.messages.campaignName) || [];
					datasets =
						response.data && response.data.messages && response.data.messages.chartDateSets ? response.data.messages.chartDateSets : [];
					if (
						response.data &&
						response.data.messages &&
						response.data.messages.chartDateSets &&
						response.data.messages.chartDateSets.length > 0
					) {
						datasets.map((value, i) => {
							let random = colorsList[i] || getRandomColors();
							value.type = state.chartType || 'line';
							value.fill = false;
							value.backgroundColor = random;
							value.borderColor = random;
							value.hoverBackgroundColor = random;
							value.hoverBorderColor = random;
							value.borderWidth = 0;
							value.maxBarThickness = 15;
							value.barThickness = 5;
							value.barPercentage = 0.2;
							value.categoryPercentage = 0.2;
							return value;
						});

						resolve({ labels: labe, datasets, campaignList });
					} else {
						resolve({ labels, datasets, campaignList });
					}
				})
					.then((data) => {
						setCommissionData({
							...commissionData,
							...request,
							campaignList: data.campaignList || [],
							labels: data.labels || [],
							campaignValue: ['ALL'],
							datasets: data.datasets || [],
							datasetsTemp: data.datasets || [],
						});
						setchartLoading(false);
					})
					.catch(() => {
						setchartLoading(false);
					});
			})
			.catch(() => {
				setchartLoading(false);
			});
	};

	const getAffiliateChartData = async (request) => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();
		setchartLoading(true);
		Axios.get(`${appConstant.domain + apiUrl.GET_AFFILIATE_USAGE_CHART_DATA + authKey}`, {
			headers: { Authorization: authToken },
			params: {
				startDate: moment(request.startDate).format(dateFormat) || moment(new Date().setDate(new Date().getDate() - 7)).format(dateFormat),
				endDate: moment(request.endDate).format(dateFormat) || moment(new Date()).format(dateFormat),
			},
		})
			.then((response) => {
				// if (response.data.result == 'SUCCESS') {
				let labels = [];
				let datasets = [];
				new Promise((resolve) => {
					labels = response.data && response.data.messages && response.data.messages.labels ? response.data.messages.labels : [];
					// let labe = [];
					// labels.forEach((e, index) => {
					// 	labe[index] = moment(e).format(dateFormat);
					// });
					let campaignList = (response.data && response.data.messages && response.data.messages.affiliateName) || [];
					datasets =
						response.data && response.data.messages && response.data.messages.chartDataSets ? response.data.messages.chartDataSets : [];
					if (
						response.data &&
						response.data.messages &&
						response.data.messages.chartDataSets &&
						response.data.messages.chartDataSets.length > 0
					) {
						datasets.map((value, i) => {
							let random = colorsList[i] || getRandomColors();
							value.type = 'bar' || 'line';
							value.fill = false;
							value.backgroundColor = random;
							value.borderColor = random;
							value.hoverBackgroundColor = random;
							value.hoverBorderColor = random;
							value.borderWidth = 0;
							value.maxBarThickness = 15;
							value.barThickness = 5;
							value.barPercentage = 0.2;
							value.categoryPercentage = 0.2;
							return value;
						});

						resolve({ labels: labels, datasets, campaignList });
					} else {
						resolve({ labels, datasets, campaignList });
					}
				})
					.then((data) => {
						setAffiliateData({
							...affiliateData,
							...request,
							labels: data.labels || [],
							datasets: data.datasets || [],
						});
						setaffiliateChartLoading(false);
					})
					.catch(() => {
						setaffiliateChartLoading(false);
					});
			})
			.catch(() => {
				setaffiliateChartLoading(false);
			});
	};

	const getCommissionProfiles = async () => {
		const authKey = await getAuthKey();
		const authToken = await getAuthToken();
		Axios.get(`${appConstant.domain + apiUrl.GET_AFFILIATE_BY_ID_COMMISSION_PROFILE}${userDetails.sourceId}`, {
			headers: {
				Authorization: authToken,
			},
			params: {
				authKey: authKey,
			},
		})
			.then((res) => {
				setcommissionProfileData({
					...commissionProfileData,
					commissionProfilesLoading: false,
					data: res.data.messages.message,
				});
			})
			.catch((err) => {
				setcommissionProfileData({
					...commissionProfileData,
					commissionProfilesLoading: false,
					data: [],
				});
			});
	};

	const getBankDetails = async () => {
		const authKey = await getAuthKey();
		const authToken = await getAuthToken();
		Axios.get(`${appConstant.domain + apiUrl.GET_ACTIVE_BANK + authKey}`, {
			headers: {
				Authorization: authToken,
			},
		})
			.then((getActiveBankResponse) => {
				if (getActiveBankResponse.data.success && getActiveBankResponse.data.messages.length > 0) {
					let arr = [];
					getActiveBankResponse.data.messages.map((res) => {
						if (res.isActive) {
							setBankForm({
								...bankForm,
								bankName: res.bankName || '',
								accountNickName: res.accountNickName || '',
								accountType: res.accountType || '',
								routingNumber: res.routingNumber || '',
								confirmRoutingNumber: res.confirmRoutingNumber || '',
								accountNumber: res.accountNumber || '',
								confirmAccountNumber: res.confirmAccountNumber || '',
							});
						} else {
							arr.push(res);
						}
						return res;
					});
				}
				setState({
					...state,
					loading: false,
				});
			})
			.catch(() => {
				removeUser(userDetails.authKey, history);
				setState({
					...state,
					loading: false,
				});
			});
	};

	const [bankForm, setBankForm] = useState({
		bankName: '',
		accountNickName: '',
		accountType: '',
		routingNumber: '',
		accountNumber: '',
		confirmRoutingNumber: '',
		confirmAccountNumber: '',
	});

	const [companyEncryptId, setcompanyEncryptId] = useState('')

	const handleBankChange = (label, value) => {
		setBankForm({
			...bankForm,
			[label]: value,
		});
	};

	const handleChartDataType = (label, value) => {
		setPerformanceData({ ...performanceData, chartDataType: value });
		let request = {
			...performanceData,
			[label]: value,
		};
		getPerfomanceChartData(request);
	};

	const closeTermsModal = () => setTermsModalVisible(false);

	const getEncryptComId = async (id) => {
		let encryptId = await encryptCompanyId(id)
		setcompanyEncryptId(encryptId)
	};

	useEffect(() => {
		getBankDetails();
		getPerfomanceChartData(performanceData);
		getCommissionChartData(commissionData);
		if (isAuth(showAffiliateUsageChart, userDetails && userDetails.accessLevel)) getAffiliateChartData(affiliateData);
		if (isAuth(bankCard, userDetails && userDetails.accessLevel)) getCommissionProfiles();
		getAllCampaigns();
		getEncryptComId(userDetails && userDetails.companyId)
	}, []);

	return (
		<DashboardPresentation
			closeTermsModal={closeTermsModal}
			termsModalVisible={termsModalVisible}
			handleBankChange={handleBankChange}
			bankForm={bankForm}
			state={state}
			bardata={bardata}
			bardata1={bardata1}
			linedata={linedata}
			performanceData={performanceData}
			handleChartDataType={handleChartDataType}
			commissionData={commissionData}
			affiliateData={affiliateData}
			performanceChartLoading={performanceChartLoading}
			chartLoading={chartLoading}
			props={props}
			history={history}
			userDetails={userDetails}
			companyEncryptId={companyEncryptId}
			commissionProfileData={commissionProfileData}
			setaffiliateChartLoading={setaffiliateChartLoading}
			affiliateChartLoading={affiliateChartLoading}
			reportData={reportData}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		removeUser: (authKey, history) => dispatch(ActionsApp.creators.removeUser(authKey, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(DashboardFunctional);

export default Connected;
